export default (state='', action) => {
    if(action.type === 'SET_TERM') {
        state = action.term;
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/search.js